export enum MobilityType {
    ENSEIGNANT,
    ETUDIANT 
}